import '@babel/polyfill';

import 'dom4';

import smoothscroll from 'smoothscroll-polyfill';

import FastClick from 'fastclick';

import './global';

smoothscroll.polyfill();
FastClick.attach(document.body);
